import React from 'react';
import { XStack, YStack, View, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

interface TemperatureLabelProps {
  icon: React.ReactNode;
  temperature: string;
  location: string;
}

export const TemperatureLabel: React.FC<TemperatureLabelProps> = ({
  icon,
  temperature,
  location,
}) => (
  <XStack flex={1} alignItems="center" space={20}>
    <View
      backgroundColor={tokens.color.gray3}
      borderRadius={80}
      width={115}
      height={115}
      justifyContent="center"
      alignItems="center">
      {icon}
    </View>
    <YStack alignItems="center">
      <Text fontFamily="$heading" fontSize="$9" fontWeight="$5">
        {temperature}
      </Text>
      <Text fontFamily="$body" fontSize="$9" fontWeight="$4">
        {location}
      </Text>
    </YStack>
  </XStack>
);
